<template>
  <div>
    <v-icon
      small
      title="Comparativo de Preços"
      class="ml-1"
      @click="abrirDialog()"
    >
      mdi-cash-multiple
    </v-icon>

    <SysDialog
      v-model="dialog"
      titulo="Comparativo de Preços"
      :largura="1100"
      ocultarAcoes
      class="pa-0"
      content-class="bra-20"
      @click:hidden-dialog="itens_tabela = []"
    >
      <Tabela
        :itens="itens_tabela"
        :produto="produto"
      />
    </SysDialog>
  </div>
</template>

<script>
import { buscarComparativo } from '@/api/compras/ComparativoPreco';
import SysDialog from '../../../padraoDeLayout/SysDialog.vue';
import Tabela from './Tabela.vue';

export default {
  name: 'ComparativoPreco',
  components: { SysDialog, Tabela },
  props: {
    produto: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      itens_tabela: []
    }
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
      this.buscarComparartivoDoProduto();
    },
    buscarComparartivoDoProduto() {
      const parametros = {
        idgrupo: this.produto.id_grupo,
        idproduto: this.produto.id_produto
      }

      this.$store.dispatch(
        'loading/addRequisicao',
        buscarComparativo(parametros).then((d) => this.itens_tabela = d)
      );
    }
  }
}
</script>

<style>

</style>
